const WORDS = [
  "Slow-Cooked Oxtails",
  "Crispy Fried Chicken Wings",
  "Homemade Mac & Cheese",
  "Smothered Turkey Wings",
  "Southern Hospitality",
  "Made With Love",
];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <div data-testid="marquee" className="bg-burgundy text-cream py-5 overflow-hidden select-none">
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-heading text-lg md:text-2xl italic px-6">{w}</span>
            <span className="text-gold text-xl">&#10022;</span>
          </span>
        ))}
      </div>
    </div>
  );
};
